import { Routes, Route } from "react-router-dom";
import { useIsAuthenticated } from "react-auth-kit";
import Clients from "./pages/client/Clients";
import Home from "./pages/Home";
import Events from "./pages/event/Events";
import EventStatus from "./pages/eventStatus/EventStatus";
import FormFields from "./pages/dynamicFormFields/FormFieldList";
import WorkFlow from "./pages/workflow/WorkFlow";
import Header from "./components/Header";
import OperationalArea from "./pages/operationalArea/OperationalArea";
import EventType from "./pages/eventType/EventType";
import NoMatch from "./components/NoMatch";
import DynamicForm from "./pages/dynamicForm/DynamicForm";
import Contractor from "./pages/contractor/Contractor";
import Provider from "./pages/Provider/Provider";
import Personal from "./pages/personal/Personal";
import VehicleType from "./pages/vehicleType/VehicleType";
import Vehicle from "./pages/vehicle/Vehicle";
import TeamsList from "./pages/team/TeamsList";
import Resolutions from "./pages/resolution/Resolutions";
import MeasurementUnitList from "./pages/measurement_units/MeasurementUnitList";
import SupplyList from "./pages/supplies/SupplyList";
import AdditionalNewnessList from "./pages/additionalNewness/AdditionalNewnessList";
import NewnessList from "./pages/newness/NewnessList";
import EventDetail from "./pages/event/EventDetail";
import Login from "./pages/auth/Login";
import Profiles from "./pages/profiles/Profiles";
import Users from "./pages/users/Users";
import Position from "./pages/position/Position";
import EvidenceImageViewer from "./pages/evidence/EvidenceImageViewer";
import DynamicFormFieldValueImageViewer from "./pages/dynamicForm/components/review/DynamicFormFieldValueImageViewer";
import Report from "./pages/event/components/Report";
import Proceeding from "./pages/proceeding/Proceeding";
import Warehouse from "./pages/warehouse/Warehouse";
import PaymentTypes from "./pages/paymentTypes/PaymentTypes";
import AdditionalCostTypes from "./pages/additionalCostTypes/AdditionalCostTypes";
import PreOrders from "./pages/preOrders/PreOrders";
import EvidenceTemplate from "./pages/evidenceTemplate/EvidenceTemplate";
import Payments from "./pages/payments/Payments";
import Bill from "./pages/relatedBills/Bill";
import DailyRoutes from "./pages/dailyRoute/DailyRoutes";
import { PrintDailyRoute } from "./pages/dailyRoute/components/PrintDailyRoute";
import InventoryMovementType from "./pages/inventory/movementType/InventoryMovementType";
import InventoryMovement from "./pages/inventory/InventoryMovement/InventoryMovement";
import FormBuilder from "./pages/dynamicForm/components/FormBuilder";
import RequestTypes from "./pages/requestTypes/RequestTypes";
import GeneralRequests from "./pages/generalRequests/GeneralRequests";
import ReportTypes from "./pages/reportTypes/ReportTypes";
import BillEdition from "./pages/relatedBills/components/BillEdition";

function App() {
  const isAuthenticated = useIsAuthenticated();

  const getUI = () => {
    return (
      <>
        <Header />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/resolutions"
            element={isAuthenticated() ? <Resolutions /> : <Login />}
          >
            <Route path=":id" />
          </Route>
          <Route path="/" element={isAuthenticated() ? <Home /> : <Login />} />
          <Route
            path="/home"
            element={isAuthenticated() ? <Home /> : <Login />}
          />
          <Route
            path="/operational-area"
            element={isAuthenticated() ? <OperationalArea /> : <Login />}
          >
            <Route path=":id" />
          </Route>
          <Route
            path="/vehicles"
            element={isAuthenticated() ? <Vehicle /> : <Login />}
          >
            <Route path=":id" />
          </Route>
          <Route
            path="/vehicletypes"
            element={isAuthenticated() ? <VehicleType /> : <Login />}
          >
            <Route path=":id" />
          </Route>
          <Route
            path="/additionalnewness"
            element={isAuthenticated() ? <AdditionalNewnessList /> : <Login />}
          >
            <Route path=":id" />
          </Route>
          <Route
            path="/newness"
            element={isAuthenticated() ? <NewnessList /> : <Login />}
          >
            <Route path=":id" />
          </Route>
          <Route
            path="/workflow"
            element={isAuthenticated() ? <WorkFlow /> : <Login />}
          >
            <Route path=":id" />
          </Route>
          <Route
            path="/dynamicforms"
            element={isAuthenticated() ? <DynamicForm /> : <Login />}
          />
          <Route
            path="/dynamicforms/:id"
            element={isAuthenticated() ? <FormBuilder /> : <Login />}
          />
          <Route
            path="/formfields"
            element={isAuthenticated() ? <FormFields /> : <Login />}
          >
            <Route path=":id" />
          </Route>
          <Route
            path="/status"
            element={isAuthenticated() ? <EventStatus /> : <Login />}
          >
            <Route path=":id" />
          </Route>
          <Route
            path="/eventtype"
            element={isAuthenticated() ? <EventType /> : <Login />}
          >
            <Route path=":id" />
          </Route>
          <Route
            path="/personal"
            element={isAuthenticated() ? <Personal /> : <Login />}
          >
            <Route path=":id" />
          </Route>
          <Route
            path="/contractor"
            element={isAuthenticated() ? <Contractor /> : <Login />}
          >
            <Route path=":id" />
          </Route>
          <Route
            path="/provider"
            element={isAuthenticated() ? <Provider /> : <Login />}
          >
            <Route path=":id" />
          </Route>
          <Route
            path="/client"
            element={isAuthenticated() ? <Clients /> : <Login />}
          >
            <Route path=":id" />
          </Route>
          <Route
            path="/measurementunit"
            element={isAuthenticated() ? <MeasurementUnitList /> : <Login />}
          >
            <Route path=":id" />
          </Route>
          <Route
            path="/supply"
            element={isAuthenticated() ? <SupplyList /> : <Login />}
          >
            <Route path=":id" />
          </Route>
          <Route
            path="/position"
            element={isAuthenticated() ? <Position /> : <Login />}
          >
            <Route path=":id" />
          </Route>
          <Route
            path="/profiles"
            element={isAuthenticated() ? <Profiles /> : <Login />}
          >
            <Route path=":id" />
          </Route>
          <Route
            path="/users"
            element={isAuthenticated() ? <Users /> : <Login />}
          >
            <Route path=":id" />
          </Route>

          <Route
            path="/teams"
            element={isAuthenticated() ? <TeamsList /> : <Login />}
          />
          <Route
            path="/proceedings"
            element={isAuthenticated() ? <Proceeding /> : <Login />}
          />
          <Route
            path="/events"
            element={isAuthenticated() ? <Events /> : <Login />}
          />
          <Route
            path="/additionalCostType"
            element={isAuthenticated() ? <AdditionalCostTypes /> : <Login />}
          />
          <Route
            path="/paymentType"
            element={isAuthenticated() ? <PaymentTypes /> : <Login />}
          />
          <Route
            path="/events/detail/:id"
            element={isAuthenticated() ? <EventDetail /> : <Login />}
          />
          <Route
            path="/events/detail/:id/report/:original"
            element={isAuthenticated() ? <Report /> : <Login />}
          />
          <Route
            path="/dailyRoute/:id/report"
            element={isAuthenticated() ? <PrintDailyRoute /> : <Login />}
          />
          <Route
            path="/events/detail/:id/evidence/:evidenceId/:type"
            element={isAuthenticated() ? <EvidenceImageViewer /> : <Login />}
          />
          <Route
            path="/events/detail/:id/dynamic-form-field-value/:valueId/:original/:rotateImage"
            element={
              isAuthenticated() ? (
                <DynamicFormFieldValueImageViewer />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/warehouse"
            element={isAuthenticated() ? <Warehouse /> : <Login />}
          />
          <Route
            path="/preorder"
            element={isAuthenticated() ? <PreOrders /> : <Login />}
          />
          <Route
            path="/evidencetemplates"
            element={isAuthenticated() ? <EvidenceTemplate /> : <Login />}
          />
          <Route
            path="/registerpayments"
            element={isAuthenticated() ? <Payments /> : <Login />}
          />
          <Route
            path="/dailyRoute"
            element={isAuthenticated() ? <DailyRoutes /> : <Login />}
          />
          <Route
            path="/bills"
            element={isAuthenticated() ? <Bill /> : <Login />}
          />
          <Route
            path="/bills/:id"
            element={isAuthenticated() ? <BillEdition /> : <Login />}
          />
          <Route
            path="/inventoryMovementType"
            element={isAuthenticated() ? <InventoryMovementType /> : <Login />}
          />

          <Route
            path="/inventoryMovement"
            element={isAuthenticated() ? <InventoryMovement /> : <Login />}
          />

          <Route
            path="/requestType"
            element={isAuthenticated() ? <RequestTypes /> : <Login />}
          />

          <Route
            path="/reportType"
            element={isAuthenticated() ? <ReportTypes /> : <Login />}
          />

          <Route
            path="/generalRequests"
            element={isAuthenticated() ? <GeneralRequests /> : <Login />}
          />
          <Route path="*" element={<NoMatch />} />
        </Routes>
      </>
    );
  };

  return getUI();
}

export default App;
